import React, { useCallback } from 'react'
import { FiStopCircle } from 'react-icons/fi'
import { useSelector } from 'react-redux'

import PropTypes from 'prop-types'

import { Button } from '~/components/Buttons'
import Loading from '~/components/Loading'
import { Spinner } from '~/components/Spinner'
import useConfirmationModal from '~/hooks/useConfirmationModal'

import usePromotion from '../../hooks/usePromotion'

const FinishButton = ({ promotion, keepsMenuOpen, menuItem = false }) => {
  const [ConfirmationhModal, showConfirmationModal, toggleConfirmationModal] =
    useConfirmationModal()

  const { handleFinishPromotion } = usePromotion()

  const { loadingSaving: loading } = useSelector(state => state.promotional)

  const handleToogle = useCallback(() => {
    keepsMenuOpen && keepsMenuOpen(oldState => !oldState)

    toggleConfirmationModal()
  }, [keepsMenuOpen, toggleConfirmationModal])

  const handleSubmit = useCallback(() => {
    const data = {
      promotion,
      onSuccess: handleToogle
    }

    handleFinishPromotion(data)
  }, [handleFinishPromotion, promotion, handleToogle])

  return (
    <>
      {menuItem ? (
        <button
          type="button"
          onClick={handleToogle}
          className="danger"
          disabled={loading}
        >
          {loading ? <Spinner /> : <FiStopCircle />} <span>Finalizar</span>
        </button>
      ) : (
        <Button
          text="Finalizar"
          type="button"
          template="transparentCritical"
          size="small"
          iconLeft={loading ? <Spinner /> : <FiStopCircle />}
          customWidth="auto"
          onClick={handleToogle}
        />
      )}

      {/* Modal finalizar */}
      <ConfirmationhModal
        title="Deseja finalizar a promoção?"
        isOpen={showConfirmationModal}
        onClose={handleToogle}
        onSubmit={handleSubmit}
        confirmationButton="Entendo e desejo finalizar esta promoção"
      >
        <p>
          Esta ação não poderá ser desfeita e as ações em decorrência desse ato
          não poderão ser desfeitas.
        </p>
        <p>
          Se deseja apenas pausar a promoção e retornar em uma data breve,
          utilize a opção pausar promoção.
        </p>
        {loading && <Loading status={loading}>Finalizando promoção...</Loading>}
      </ConfirmationhModal>
    </>
  )
}

export default FinishButton

FinishButton.propTypes = {
  promotion: PropTypes.shape({}).isRequired,
  keepsMenuOpen: PropTypes.func,
  menuItem: PropTypes.bool
}

FinishButton.defaultProps = {
  menuItem: false,
  keepsMenuOpen: null
}
